import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';
import { StyleHelper } from '@xanadu/common';
import { CommonSignal } from '@xanadu/signal';
import { Reply } from '../model/reply';

@Component({
    selector: 'app-okay',
    templateUrl: './okay.component.html',
    styleUrls: ['./okay.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('okay')
export class OkayComponent {
    private readonly styleHelper = inject(StyleHelper);
    private readonly commonSignal = inject(CommonSignal);

    model = input<any>(undefined);
    style = computed(() => {
        const model = this.model();

        if (model && model.style) {
            return this.styleHelper.parse(model.style);
        }
        return undefined;
    });

    onOk(isOk: boolean) {
        const model = this.model();

        if (model) {
            const reply: Reply = {
                topic: model.topic,
                target: model.target,
                data: model.data,
                result: { isOk }
            }

            this.commonSignal.reply.set(reply);
        }
    }

}
